import { render, staticRenderFns } from "./option-modal-delete.vue?vue&type=template&id=15d9f6cc&"
import script from "./option-modal-delete.vue?vue&type=script&lang=js&"
export * from "./option-modal-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports